import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { isPurchaseOrderReadOnly } from '../../utils/purchaseOrderProgress';
import { purchaseOrderService } from '../../services/purchaseOrderService';
import PurchaseOrderForm from '../../components/PurchaseOrders/PurchaseOrderForm';
import FormLoadingSpinner from '../../components/Common/FormLoadingSpinner';
import Toast from '../../components/Common/Toast';

const EditPurchaseOrder = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    const loadOrder = async () => {
      try {
        console.log('📡 [EditPurchaseOrder] Cargando orden ID:', id);
        const response = await purchaseOrderService.getPurchaseOrder(id);
        
        if (response.success && response.data) {
          console.log('✅ [EditPurchaseOrder] Orden cargada:', response.data);
          setOrder({ ...response.data, id: parseInt(id) });
        } else {
          console.warn('⚠️ [EditPurchaseOrder] Orden no encontrada');
          setToast({
            isOpen: true,
            message: 'Orden de compra no encontrada',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/purchase-orders');
          }, 2000);
        }
      } catch (error) {
        console.error('❌ [EditPurchaseOrder] Error al cargar orden:', error);
        setToast({
          isOpen: true,
          message: error.message || 'Error al cargar la orden de compra',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/purchase-orders');
        }, 2000);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      loadOrder();
    }
  }, [id, navigate]);

  const handleSuccess = () => {
    setToast({
      isOpen: true,
      message: 'Orden de compra actualizada exitosamente',
      type: 'success'
    });
    setTimeout(() => {
      navigate('/purchase-orders');
    }, 1500);
  };

  const handleCancel = () => {
    navigate('/purchase-orders');
  };

  if (loading) {
    return (
      <div className="p-6">
        <div className="max-w-5xl mx-auto">
          <FormLoadingSpinner
            message="Cargando formulario…"
            hint="Preparando proveedores, productos y datos de la orden"
          />
        </div>
      </div>
    );
  }

  if (!order) {
    return null;
  }

  const readOnly =
    searchParams.get('modo') === 'ver' || isPurchaseOrderReadOnly(order);

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">
            {readOnly ? 'Ver Orden de Compra' : 'Editar Orden de Compra'}
          </h1>
          <p className="text-gray-600 mt-1">
            {readOnly
              ? 'Consulta de la orden (no editable en este estado)'
              : 'Modifique la información de la orden de compra'}
          </p>
          <div className="mt-2">
            <span className="text-sm font-mono text-teal-600">Código: {order.code}</span>
          </div>
        </div>

        {/* Formulario */}
        <PurchaseOrderForm
          isOpen={true}
          onClose={handleCancel}
          order={order}
          onSuccess={handleSuccess}
          isPageMode={true}
          readOnly={readOnly}
        />

        {/* Toast de notificaciones */}
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default EditPurchaseOrder;






